import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  forwardRef,
} from 'react';
import ChatBar from '../ChatBar';
import ChatBody from '../ChatBody';
import ChatFooter from '../ChatFooter';
// import ToolbarIcons from '../../../../public/icons/toolbar';
// import { AdminContext } from '../../../../context/AdminContext';
// import { useRouter } from 'next/router';
import { AdminContext } from '../../../context/AdminContext';
import ToolbarIcons from '../../../icons/toolbar';
import Api from '../../../api';
import CenterModal from '../../CenterModal';
import Loader from '../../Loader';
import styles from './styles.module.css';
import ChooseBackground from '../../../functions/chooseBackground';
import SHARED from '../../../constants';
import SearchPart from '../../../components/Searchpart';
import ChatSearch from '../ChatSearch';

const ChatPageSearch = forwardRef((props, ref) => {
  const {
    themeColor,
    privateUsers,
    setPrivateUsers,
    userChannelId,
    setUserChannelId,
    // activeUser,
    setUpdateSocket,
    setopenBox,
    content,
    setActiveUser,
    videoChatSize,
    showFirstMessage,
    setShowFirstMessage,
    sharedUserClicked,
    setSharedUserClicked,
    bg,
    backScale,
    showAbsolute,
    showSearch,
    // setUserChannelId,
  } = useContext(AdminContext);
  const [previousChannelId, setPreviousChannelId] = useState('');

  // const [dragActive, setDragActive] = useState(false);
  // const [message, setMessage] = useState('');
  // console.log(
  //   'activeUser',
  //   activeUser,
  //   activeUser?.users?.[0]?.channelUser?.pins?.length
  // );
  console.log('sharedUserClciked', sharedUserClicked);
  // const [messages, setMessages] = useState([]);
  // const [typingStatus, setTypingStatus] = useState('');
  // const [loadingFile, setLoadingFile] = useState(false);
  // const [loadingFileButton, setLoadingFileButton] = useState(false);

  // const [loadingOldMessages, setLoadingOldMessages] = useState(false);
  // const lastMessageRef = useRef(null);
  // const [selected, setSelected] = useState(false);

  // const [showUsers, setShowUsers] = useState(true);
  // // const [users, setUsers] = useState([]);
  // const router = useRouter();
  // const [count, setCount] = useState(0);
  // const [privateUsers, setPrivateUsers] = useState([]);
  // // const [users, setUsers] = useState([]);
  // const lastMessageRef = useRef(null);

  console.log('props?.chatTypePrivate', props?.chatTypePrivate);
  useEffect(() => {}, [props?.activeUser]);
  // useEffect(() => {
  //   // if (socket) {
  //   if (props?.chatTypePrivate) {
  //     ref?.current?.on('private:messageResponse', (data) => {
  //       // setMessages((perv) => [...perv, data]);
  //       console.log('mahsaaaa , ', messages, data);
  //       setMessages([...messages, data]);

  //       setLoadingFile(false);
  //       setLoadingFileButton(false);
  //       setSelected(true);
  //     });
  //   } else {
  //     ref?.current?.on('multiple:messageResponse', (data) => {
  //       setMessages([...messages, data]);
  //       setLoadingFile(false);
  //       setLoadingFileButton(false);
  //       setSelected(true);
  //     });
  //   }
  //   // }
  // }, [ref, messages]);
  // console.log('mahsaaaa se , ', props?.messages);

  const unBlockFunction = () => {
    // Api.blockUser(activeUser?.users?.[0]?.channelUserId)
    //   .then((res) => {
    //     setUpdateSocket('user');
    //     setopenBox(false);
    //   })
    //   .catch((err) => {});
    ref?.current?.emit(
      'private:blockUser',
      {
        uuid: props?.activeUser?.users?.[0]?.channelUser?.uuid,
        typeId: props?.activeUser?.typeId,
        roomId: props?.activeUser?.id,
      },
      (data) => {
        // setUpdateSocket('user');
        // setopenBox(false);
        setActiveUser({
          ...props?.activeUser,
          block: props?.activeUser.block == 1 ? 0 : 1,
        });
        props?.setServerError('');
      }
    );
  };
  // useEffect(() => {
  //   console.log('userchannelid', userChannelId);
  //   initialFunction();
  // }, [userChannelId]);

  // const initialFunction = () => {
  //   if (window.innerWidth < 600) {
  //     setShowUsers(false);
  //   }

  //   setLoadingOldMessages(true);
  //   if (props?.chatTypePrivate) {
  //     ref?.current?.on('private:messageListResponse', (response) => {
  //       console.log('chatttttttttt ====', response);
  //       setMessages(messages.concat(response?.response));
  //       setLoadingOldMessages(false);
  //     });
  //     // Api.userMessageList(
  //     //   userChannelId
  //     //   // , { params: { channelId: userChannelId } }
  //     // )
  //     //   .then((res) => {
  //     //     // setMessages(messages.concat(res?.data?.response));
  //     //     const newarray = messages.concat(res?.data?.response);
  //     //     setMessages(newarray);
  //     //     setLoadingOldMessages(false);
  //     //   })
  //     //   .catch((err) => {
  //     //     setServerError(err?.response?.data?.message);
  //     //   });
  //   } else {
  //     ref?.current?.on('multiple:messageListResponse', (response) => {
  //       setMessages(messages.concat(response?.response));
  //       setLoadingOldMessages(false);
  //     });
  //     // Api.videoMessageList(
  //     //   uuid
  //     //   // channelId, { params: { uuid: uuid } }
  //     // )
  //     //   .then((res) => {
  //     //     const newarray = messages.concat(res?.data?.response);
  //     //     setMessages(newarray);
  //     //     setLoadingOldMessages(false);
  //     //   })
  //     //   .catch((err) => {
  //     //     setServerError(err?.response?.data?.message);
  //     //   });
  //   }
  //   lastMessageRef.current?.scrollIntoView({ behavior: 'smooth' });
  // };
  // useEffect(() => {
  //   // if (socket) {
  //   if (props?.chatTypePrivate) {
  //     ref?.current?.on(
  //       'private:typingResponse',
  //       // { type: '' },
  //       // { channelId: userChannelId },
  //       (data) => {
  //         console.log('type==', data);
  //         setTypingStatus(data);
  //       }
  //     );
  //   } else {
  //     ref?.current?.on('multiple:typingResponse', (data) =>
  //       setTypingStatus(data)
  //     );
  //   }
  //   // }
  // }, [ref]);

  useEffect(() => {
    // if (loadingOldMessages) {
    props?.lastMessageRef?.current?.scrollIntoView({ behavior: 'smooth' });
    // }
  }, [props?.loadingOldMessages]);

  useEffect(() => {
    // 👇️ scroll to bottom every time messages change
    // lastMessageRef.current?.scrollIntoView({ behavior: 'smooth' });
    let container = document.getElementById('messageContainer');
    console.log(
      'container==',
      container?.scrollHeight,
      container?.clientHeight,
      container?.scrollTop,
      Math.abs(
        container?.scrollHeight - container?.clientHeight - container?.scrollTop
      )
    );
    if (
      Math.abs(
        container?.scrollHeight - container?.clientHeight - container?.scrollTop
      ) < 350
    ) {
      props?.lastMessageRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [props?.messages]);

  // console.log('filessss', messages);
  useEffect(() => {}, [showFirstMessage]);
  // console.log('serverError', props?.serverError);
  // console.log('showFirstMessage==', showFirstMessage);
  // console.log('showUsers', props?.showUsers, showAbsolute);
  console.log('showSearch', showSearch, showFirstMessage);

  return (
    <div className="chat relative chatPage" id="chatpage">
      {!props?.onlineStatus && (
        <div className={`${'connectionError'}`}>{content.offlineText}</div>
      )}
      {/* {router?.pathname?.includes('/channel') == false && ( */}

      <ChatSearch
        ref={props?.ref}
        setServerError={props?.setServerError}
        fileType={props?.fileType}
        loadingFile={props?.loadingFile}
        setLoadingFile={props?.setLoadingFile}
        loadingFileButton={props?.loadingFileButton}
        setLoadingFileButton={props?.setLoadingFileButton}
        setLoadingOldMessages={props?.setLoadingOldMessages}
        setTypingStatus={props?.setTypingStatus}
        users={props?.users}
        chatTypePrivate={props?.chatTypePrivate}
        replyValue={props?.replyValue}
        setReplyValue={props?.setReplyValue}
        setMessages={props?.setMessages}
        content={props?.content}
        handleSendMessage={props?.handleSendMessage}
        sendFunction={props?.sendFunction}
        notTyping={props?.notTyping}
        message={props?.message}
        setMessage={props?.setMessage}
        handleDrag={props?.handleDrag}
        handleDrop={props?.handleDrop}
        sendContact={props?.sendContact}
      />
      {/* )} */}

      <div
        // className={` chat__main ${
        //   ChooseBackground(bg)?.repeat ? 'repeatBg' : 'noRepeatBg'
        // }`}
        className="chat__main"
        style={{
          // backgroundImage: `url(${ChooseBackground(bg)?.src})`,
          // // backgroundSize: '200px',
          // // backgroundSize: `${SHARED.maxBgScale * backScale}px`,
          // backgroundSize: ChooseBackground(bg)?.cover
          //   ? 'cover'
          //   : `${SHARED.maxBgScale * backScale}px`,
          height: `100%`,
          position: 'relative',
        }}
      >
        <div
          className={` ${styles.absoluteBg} darkMode ${
            ChooseBackground(bg)?.repeat ? 'repeatBg' : 'noRepeatBg'
          }`}
          style={{
            backgroundImage: `url(${ChooseBackground(bg)?.src})`,
            // backgroundSize: '200px',
            // backgroundSize: `${SHARED.maxBgScale * backScale}px`,
            backgroundSize: ChooseBackground(bg)?.cover
              ? 'cover'
              : `${SHARED.maxBgScale * backScale}px`,
            // height: `100%`,
          }}
        ></div>
        <div
          className={`messageContainerShadow flex flex-row justify-center items-center `}
        >
          <p className={`mx-auto noContent`}>{content?.noContent}</p>
        </div>
      </div>
    </div>
  );
});

export default ChatPageSearch;
